const mod = require('@material-ui/core/styles')

module.exports = mod
